"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LvAnnualRenewalDeclineNavigator_1 = require("./LvAnnualRenewalDeclineNavigator");
var LvAnnualRenewalDeclineNavigatorNoCancelButton = /** @class */ (function (_super) {
    __extends(LvAnnualRenewalDeclineNavigatorNoCancelButton, _super);
    function LvAnnualRenewalDeclineNavigatorNoCancelButton(props) {
        var _this = _super.call(this, props) || this;
        _this.clickPrev = _this.clickPrev.bind(_this);
        return _this;
    }
    LvAnnualRenewalDeclineNavigatorNoCancelButton.prototype.renderJourneyButtons = function () {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    LvAnnualRenewalDeclineNavigatorNoCancelButton.prototype.renderJourneyBody = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "journey-questions-body", children: (0, jsx_runtime_1.jsxs)("div", { className: "journey-questions-body-content", children: [this.props.children, this.renderNextButton()] }) }));
    };
    return LvAnnualRenewalDeclineNavigatorNoCancelButton;
}(LvAnnualRenewalDeclineNavigator_1.default));
exports.default = LvAnnualRenewalDeclineNavigatorNoCancelButton;
//# sourceMappingURL=LvAnnualRenewalDeclineNavigatorNoCancelButton.js.map